import React, { useEffect } from 'react';
import { PencilSquareIcon } from '@heroicons/react/24/solid';

const BranchTable = ({ branches, handleToggleStatus, handleEdit, onBranchSelected }) => {
  const u = value => String(value ?? '').toUpperCase();

  return (
    <div className="hidden md:block overflow-x-auto">
      <table className="min-w-full table-auto bg-white rounded shadow text-sm">
        <thead className="bg-[#293686] text-white uppercase text-left">
          <tr className="bg-[#293686] uppercase text-left text-sm font-semibold text-white">
            <th className="px-4 py-2">Code</th>
            <th className="px-4 py-2">Name</th>
            <th className="px-4 py-2">Contact</th>
            <th className="px-4 py-2">Phone</th>
            <th className="px-4 py-2">Email</th>
            <th className="px-4 py-2">Location</th>
            <th className="px-4 py-2">GST No</th>
            <th className="px-4 py-2">Status</th>
            <th className="p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {branches.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center py-4">
                No branches found.
              </td>
            </tr>
          ) : (
            branches.map(branch => (
              <tr key={branch?.code} className="border-t text-sm">
                <td className="px-4 py-2  text-[#E91C24] font-bold">
                  <div className="cursor-pointer" onClick={() => onBranchSelected(branch)}>
                    {u(branch?.branch_code)}
                  </div>
                </td>
                <td className="px-4 py-2">{u(branch?.name)}</td>
                <td className="px-4 py-2">{u(branch?.contact_name)}</td>
                <td className="px-4 py-2">{branch?.contact_number}</td>
                <td className="px-4 py-2">{u(branch?.email)}</td>
                <td className="p-2 whitespace-pre-line">
                  {u([
                    branch?.address_line_1,
                    branch?.address_line_2,
                    branch?.city,
                    branch?.state,
                    branch?.pincode,
                  ]
                    .filter(Boolean)
                    .join('\n'))}
                </td>
                <td className="px-4 py-2">{u(branch?.gst_number)}</td>
                <td
                  className={`p-2 cursor-pointer hover:underline ${
                    branch.is_active ? 'text-green-600' : 'text-red-500'
                  } font-medium`}
                  onClick={() => handleToggleStatus(branch)}
                >
                  {branch.is_active ? 'ACTIVE' : 'INACTIVE'}
                </td>
                <td className="p-2">
                  <button onClick={() => handleEdit(branch)}>
                    <PencilSquareIcon className="h-5 w-5 text-blue-600 hover:text-blue-800" />
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default BranchTable;
